import { errorHandler } from "@/lib/utils";
import { useState } from "react";
import { toast } from "sonner";

interface UseFormSubmitProps<T> {
  id?: number | string;
  createService?: (data: T) => Promise<unknown>;
  updateService: (id: number | string, data: T) => Promise<unknown>;
  onSuccess: () => void;
  onError?: (err: unknown) => void;
}

export const useFormSubmit = <T>({
  id,
  createService,
  updateService,
  onSuccess,
  onError,
}: UseFormSubmitProps<T>) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: T) => {
    setLoading(true);
    try {
      if (id) {
        await updateService(id, values);
      } else {
        if (createService) await createService(values);
      }

      toast.success("Registro salvo com sucesso");
      onSuccess();
    } catch (err) {
      errorHandler(err, "Erro ao salvar dados.");
      onError?.(err);
    } finally {
      setLoading(false);
    }
  };

  return { handleSubmit, loading };
};
